import { useTranslations } from 'next-intl';
import BringOrder from '@/components/bring-order/BringOrder';

const WebPlatformBringOrderSection = () => {
  const t = useTranslations('WebPlatformBringOrderSection');

  return (
    <BringOrder
      title={t('title')}
      description={t('description')}
      primaryBtn={t('primaryBtn')}
      secondaryBtn={t('secondaryBtn')}
      secondaryBtnLink="/coming-soon"
    />
  );
};
export default WebPlatformBringOrderSection;
